import React from "react";

import DefaultBL from "../../gallery/default/defaultBusinessLogo.png";
import { resetAskSignup, resetGuest, setAskTicket, unSetHomeModal } from "../../app/features/user/userSlice";
import { resetTimer } from "../../app/features/timer/timerSlice";
import { useDispatch } from "react-redux";
import BuyTicket from "../../gallery/icons/buy-ticket.svg";
import { getTicketingUrl, isExternalEvent, openExternalTicketing } from "../../utils/eventTicketing";

export default function EventDescription({ currentEvent, externalOnly = false }) {
  let data = currentEvent;

  const dispatch = useDispatch();
  const external = externalOnly || isExternalEvent(data);
  const externalUrl = getTicketingUrl(data);

  const goToTickets = () => {
    if (external) {
      openExternalTicketing(data);
      return;
    }
    dispatch(setAskTicket());
    dispatch(resetAskSignup());
    dispatch(resetGuest());
    dispatch(resetTimer());
    dispatch(unSetHomeModal());
  };

  const handleExternalBuy = () => {
    openExternalTicketing(data);
  };

  const dateFormat = (d) => {
    let date = new Date(d);
    const dayOfWeek = date.toLocaleString("en-US", { weekday: "long" });
    var month = date.toLocaleString("en-US", { month: "short" });
    const year = date.getFullYear();
    const day = date.getDate();

    const formattedDate = `${dayOfWeek}, ${day} ${month} ${year}`;

    return formattedDate;
  };

  const timeFormat = (d) => {
    let date = new Date(d);

    let hours = date.getHours();
    const minutes = date.getMinutes();
    const ampm = hours >= 12 ? "PM" : "AM";

    hours = hours % 12;
    hours = hours ? hours : 12;

    const formattedDate = `${hours}:${minutes < 10 ? "0" + minutes : minutes} ${ampm}`;

    return formattedDate;
  };
  return (
    <div className="container">
      <div className="row">
        <div className="col-12">
          <div className="col-12 d-flex justify-content-center mb-3">
            {data && data.image_name && <img className="d-block carousel-img-height img-fluid" alt="..." src={data.image_name ? data.image_path : DefaultBL} />}
          </div>
          <h3 className="text-center text-red">{currentEvent.name}</h3>
          <h5 className="text-center text-red">
            {data.address1 ? `${data.address1}, ` : ""}
            {data ? (data.location ? data.location : "") : ""}
          </h5>
          <h5 className="text-center text-red">{dateFormat(data.start_date)}</h5>
          <h5 className="text-center text-red">{timeFormat(data.start_date)} onwards</h5>

          {externalOnly && externalUrl && (
            <button type="button" className="btn btn-event-modal mt-4 w-100" onClick={handleExternalBuy}>
              <img src={BuyTicket} alt="" className="me-3" />
              Buy tickets
            </button>
          )}
          {!externalOnly && external && externalUrl && (
            <button type="button" className="btn btn-event-modal mt-4 w-100" onClick={handleExternalBuy}>
              <img src={BuyTicket} alt="" className="me-3" />
              Buy tickets
            </button>
          )}
          {!externalOnly && !external && (
            <button className="btn btn-event-modal mt-4 w-100" type="button" onClick={() => goToTickets()}>
              <img src={BuyTicket} alt="" className="me-3" />
              Buy tickets
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
